<template>
  <div class="settings-preference-table-container">
    <header>
      <h2>{{ title }}</h2>
    </header>
    <div class="settings-preference-table-content">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SettingsPreferenceTable',
  props: {
    title: String,
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

.settings-preference-table-container {
  margin: 0.5rem auto 2.5rem;
  max-width: 40rem;
  display: flex;
  flex-direction: column;

  header {
    padding: 0 1rem 0.75rem;

    h2 {
      font-weight: normal;
    }
  }

  .settings-preference-table-content {
    border-radius: 0.5rem;
    background: $light-background;
    display: flex;
    flex-direction: column;
  }
}
</style>
